import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  units: null,
  filters: null,
  isUnitTourScreen: false,
  bedrooms: null,
  budgets: null,
  allFloorPlans: null,
  searchResult: true,
};

export const unitSlice = createSlice({
  name: "units",
  initialState,
  reducers: {
    setUnits: (state, action) => {
      state.units = action.payload;
    },
    setIsUnitTourScreen: (state, action) => {
      state.isUnitTourScreen = action.payload;
    },
    setUnitFilters: (state, action) => {
      state.filters = action.payload;
    },
    setBedRooms: (state, action) => {
      state.bedrooms = action.payload;
    },
    setBudgets: (state, action) => {
      state.budgets = action.payload;
    },
    setAllFloorPlans: (state, action) => {
      state.allFloorPlans = action.payload;
    },
    setSearchResult: (state, action) => {
      state.searchResult = action.payload;
    },
  },
});

export const unitSliceData = (state) => state.units;

export const { setUnits, setIsUnitTourScreen, setUnitFilters, setBedRooms, setBudgets, setSearchResult, setAllFloorPlans } = unitSlice.actions;

export default unitSlice.reducer;
